<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Header from '@pages/home/components/Header.vue'
import Footer from '@pages/home/components/Footer.vue'

const isScrolled = ref(false)
const handleScroll = () => (isScrolled.value = window.scrollY > 10)

onMounted(() => window.addEventListener('scroll', handleScroll))
onBeforeUnmount(() => window.removeEventListener('scroll', handleScroll))
</script>

<template>
  <div class="relative min-h-screen bg-gray-50">
    <Header :isScrolled="isScrolled" />

    <!-- Hero -->
    <section class="bg-primary-100 py-24 text-center mt-16">
      <h2 class="text-4xl font-bold text-primary-700 mb-4">About Us</h2>
      <p class="max-w-2xl mx-auto text-gray-600 text-lg">
        At Bn Mas'ud College, we are dedicated to providing an exceptional educational environment
        that combines academic excellence with moral and spiritual growth.
      </p>
    </section>

    <!-- Mission & Vision -->
    <section class="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-10">
      <div class="bg-white rounded-2xl shadow p-8 hover:shadow-lg">
        <h3 class="text-2xl font-bold text-primary-700 mb-4">Our Mission</h3>
        <p class="text-gray-600 leading-relaxed">
          To nurture knowledgeable, ethical, and innovative learners who will make meaningful
          contributions to society and uphold the values of truth and excellence.
        </p>
      </div>

      <div class="bg-white rounded-2xl shadow p-8 hover:shadow-lg">
        <h3 class="text-2xl font-bold text-primary-700 mb-4">Our Vision</h3>
        <p class="text-gray-600 leading-relaxed">
          To be a globally recognized institution for quality education rooted in sound moral principles.
        </p>
      </div>
    </section>

    <Footer />
  </div>
</template>
